import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import PropTypes from 'prop-types';
import DialogContentText from "@material-ui/core/DialogContentText";


// WARN: copied from Grocery
const ModalDialog = (props) => {
	return (
		<Dialog fullWidth open={props.open} onClose={props.handleClose}>
			<DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
			{ props.descr ? <DialogContentText>{props.descr}</DialogContentText> : null }
			<DialogContent>{props.children}</DialogContent>
			<DialogActions>
				{ props.hideCancel ? null : <Button onClick={props.handleClose} color="default">Cancel</Button> }
				{props.middleButton}
				<Button onClick={props.handleSubmit} color="primary">
					{props.submitString || "Save"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

ModalDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	descr: PropTypes.string,
	submitString: PropTypes.string,
	middleButton: PropTypes.object
};

export default ModalDialog;